import {
  Environment
} from '@vodacom/web-env';

import {
  JavascriptTypes
} from '../constants';

import {
  AppState,
  getStorageWithExpiry,
  isValidEncMsisdn,
  mapBundleBalance
} from 'helpers';

export class CommonProvider {

  static BASE_URL = Environment.current.apiHost + Environment.current.apiBase;
  static STATE = AppState.with('CommonProvider');
  static DEFAULT_HEADERS = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };

  static getMsisdn() {
    return getStorageWithExpiry('msisdn', 'encMsisdn', '');
  }

  static async getMsisdnDetails(
    encMsisdn
  ) {

    if (!isValidEncMsisdn(encMsisdn)) {

      return {
        ok: false,
        error: new Error('Invalid encrypted msisdn'),
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    }

    return CommonProvider.STATE.makeServiceCall(
      `${CommonProvider.BASE_URL}subscriberType`,
      {
        method: 'POST',
        headers: {},
        bodyParams: {
          'id': encMsisdn
        }
      }
    )
      .then((res) => {

        if (!res?.result) {

          return {
            ok: false,
            error: new Error('Get msisdn details failed'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }

        return res;
      })
      .catch((error) => {

        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: null,
          code: null,
          stamp: new Date()
        };
      });
  }

  static async subscriptionLogger(subscriptionId) {

    return CommonProvider.STATE.makeServiceCall(
      `${CommonProvider.BASE_URL}upstream/subscriptions`,
      {
        method: 'POST',
        headers: {},
        bodyParams: {
          'id': CommonProvider.getMsisdn(),
          'subscriptionId': subscriptionId
        }
      }
    )
      .then((res) => {

        return res;
      })
      .catch((error) => {

        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: null,
          code: error?.response?.status,
          stamp: new Date()
        };
      });
  }

  static async getBundleBalances() {

    const msisdn = CommonProvider.getMsisdn();

    if (!msisdn) {
      return {
        ok: false,
        error: new Error('Invalid msisdn.')
      };
    }

    return CommonProvider.STATE.makeServiceCall(
      `${CommonProvider.BASE_URL}bundle/balances`,
      {
        method: 'POST',
        headers: {},
        bodyParams: {
          'id': msisdn
        },
        mapper: mapBundleBalance
      }
    )
      .then((res) => {

        return res;
      })
      .catch((error) => {

        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: null,
          code: error?.response?.status,
          stamp: new Date()
        };
      });
  }

  static async getCachedItem(key, fallback, serviceFallback) {

    const cachedItem = CommonProvider.STATE.getItem(key, fallback);

    if (!cachedItem && serviceFallback && typeof serviceFallback === JavascriptTypes.Function) {
      const response = await serviceFallback();

      if (response.ok && response.result) {
        return response;
      }
    }

    return cachedItem;
  }

  static deleteCachedItem(key) {
    CommonProvider.STATE.removeItem(key);
  }
}
